import styled from "styled-components";

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 80px);
    gap: 10px;
`

export const Cell = styled.div`
    padding: 8px 16px;
    border-radius: 16px;
    border: 1px solid rgba(197, 193, 193, 0.77);
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 400;

    &:hover {
        background-color: #f6f6f6;
        border: 0;
        cursor: pointer;
    }
`